/// <amd-module name="Search/Shared/Components/HighlightComponent/index" />
export * from "./HighlightComponent";
export * from "./HighlightComponent.Props";
